<app-dialog>
  <app-dialog-title>{{
    'SHARED.COMPONENTS.PROFILE_AVATAR.CROPPER_DIALOG_HEADER' | translate
  }}</app-dialog-title>
  <app-dialog-content>
    <p class="profile-avatar-cropper-dialog__instructions">
      {{ 'SHARED.COMPONENTS.PROFILE_AVATAR.CROPPER_DIALOG_INSTRUCTIONS' | translate }}
    </p>

    <div class="profile-avatar-cropper-dialog__layout">
      <section
        class="profile-avatar-cropper-dialog__panel"
        aria-label="{{
          'SHARED.COMPONENTS.PROFILE_AVATAR.CROPPER_DIALOG_CROP_AREA_LABEL' | translate
        }}">
        <header class="profile-avatar-cropper-dialog__panel-header">
          <h3 class="profile-avatar-cropper-dialog__panel-title">
            {{ 'SHARED.COMPONENTS.PROFILE_AVATAR.CROPPER_DIALOG_CROP_AREA_LABEL' | translate }}
          </h3>
        </header>
        <div class="profile-avatar-cropper-dialog__panel-body">
          <div class="profile-avatar-cropper-dialog__cropper-frame">
            <image-cropper
              #cropper
              class="imageCropper"
              [imageBase64]="data.dataURL"
              [roundCropper]="true"
              [output]="'base64'"
              [format]="'png'"
              [autoCrop]="true"
              [resizeToWidth]="data.cropperSettings.croppedWidth"
              [resizeToHeight]="data.cropperSettings.croppedHeight"
              [cropperFrameAriaLabel]="
                'SHARED.COMPONENTS.PROFILE_AVATAR.CROPPER_DIALOG_CROP_AREA_LABEL' | translate
              "
              (cropperReady)="cropperReady()"
              (imageCropped)="imageCropped($event)" />
          </div>
        </div>
      </section>

      <section
        class="profile-avatar-cropper-dialog__panel"
        aria-label="{{
          'SHARED.COMPONENTS.PROFILE_AVATAR.CROPPER_DIALOG_PREVIEW_LABEL' | translate
        }}">
        <header class="profile-avatar-cropper-dialog__panel-header">
          <h3 class="profile-avatar-cropper-dialog__panel-title">
            {{ 'SHARED.COMPONENTS.PROFILE_AVATAR.CROPPER_DIALOG_PREVIEW_LABEL' | translate }}
          </h3>
        </header>
        <div class="profile-avatar-cropper-dialog__panel-body" aria-live="polite">
          @if (croppedImageBase64) {
            <img
              [src]="croppedImageBase64"
              class="rounded-circle imageCropper-preview"
              alt=""
              [width]="data.cropperSettings.croppedWidth"
              [height]="data.cropperSettings.croppedHeight" />
          }
        </div>
      </section>
    </div>
  </app-dialog-content>
  <app-dialog-actions>
    <button
      matButton="filled"
      type="button"
      [attr.aria-label]="'SHARED.SYSTEM.USE_IMAGE' | translate"
      [disabled]="!croppedImageBase64"
      (click)="saveCroppedImage()">
      {{ 'SHARED.SYSTEM.USE_IMAGE' | translate }}
    </button>
  </app-dialog-actions>
</app-dialog>
